import { isDefined } from '@hover/utilities';

import type { AiImageEdits } from 'src/shared/graphql/generated';

import { MY_UPLOAD_STYLE } from '../static_values';
import type {
  AiOrSampleDisplayImage,
  AiOrSampleGeneratedImage,
} from '../types';
import { isDisplay, isMyUpload, pickImage } from '../types';

import { useHomeownerTranslate } from './useHomeownerTranslate';

const getEditNames = (edits: AiImageEdits) =>
  Object.values(edits)
    .map(edit =>
      edit &&
      typeof edit === 'object' &&
      '__typename' in edit &&
      (edit.__typename === 'AiImageRegionEdits' ||
        edit.__typename === 'AiImageWallEdits')
        ? edit.paint?.name ?? edit.material?.name
        : null,
    )
    .filter(isDefined);

export const useAltTextForImage = (
  image: AiOrSampleDisplayImage | AiOrSampleGeneratedImage | undefined | null,
) => {
  const t = useHomeownerTranslate();

  if (!image) return '';

  if (isDisplay(image) && isMyUpload(image)) {
    return t('images.myUploadAlt', { spaceType: image.spaceType });
  }

  const { edits, style, spaceType } = pickImage(image);

  if (edits) {
    const names = getEditNames(edits);

    if (style === MY_UPLOAD_STYLE) {
      return t('images.editedAlt', { edits: names, spaceType });
    }

    return t('images.styledAndEditedAlt', { edits: names, style, spaceType });
  }

  return t('images.styledAlt', { style, spaceType });
};
